import { useEffect, useState } from "react";
import { Button, Spin } from "antd";
import { Row, Col } from "reactstrap";
import Lottie from "lottie-react";
import lockAnim from "../../../assets/animations/lock.json";
import toast from "react-hot-toast";

import OtpInputBlock from "./OtpInput";
import useCountdown from "../../hooks/useCountdown";
import { activeQRCodeAuth, generateQRCodeAuth,} from "../../../modules/auth/services/otpApi";
import TwoFaEnabled from "./TwoFaEnabled";
import { useAuth } from "../../context/AuthContext";

const QrCodeSetup = ({ username }) => {
  const { authUser, setAuthUser } = useAuth();
  const [qrCode, setQrCode] = useState(null);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const countdown = useCountdown(30);
  const twoFaEnabled = authUser?.user?.twoFaEnabled;

  useEffect(() => {
    const load = async () => {
      try {
        const res = await generateQRCodeAuth(username);
        setQrCode(res?.qrCodeImage);
      } catch (error) {
        toast.error("Erreur lors de la génération du QR Code");
      }
    };
    load();
  }, [username]);

  const handleVerify = async () => {
    if (otp.length !== 6) {
      toast.error("Le code doit contenir 6 chiffres");
      return;
    }
    setLoading(true);
    try {
      const res = await activeQRCodeAuth({ username, code: otp });
      
      if (res?.statusCode === 200) {

        const updatedUser = {
          ...authUser,
          user: {
            ...authUser.user,
            twoFaEnabled: true
          }
        };
        setAuthUser(updatedUser);
        toast.success(res?.message);

      } else {
        setError(res?.message || "erreur");
      }
    } catch (e) {
      toast.error("Une erreur est survenue.", e?.message);
    }

    setLoading(false);
  };
  
    return (   
        !twoFaEnabled ? (
            <Row className="double-step1">
                {error && <div className="alert alert-danger">{error}</div>}
                <Col lg={6} className="double-qr-section text-center">
                  <h6 className="double-qr-title mb-3">Scannez le code QR</h6>

                  <div className="double-qr-container text-center">
                    {qrCode ? (
                        <img src={qrCode} alt="QR Code" className="double-qr-image" />
                    ) : (
                        <div className="double-loading-state">
                            <span className="ms-2">Chargement...</span><Spin /> 
                        </div>
                    )}
                  </div>

                  <p className="double-qr-text mt-3">
                    Avec votre application Google Authenticator.
                  </p>
                </Col>

                <Col lg={1} className="double-divider-col">
                  <div className="double-vertical-divider" />
                </Col>

                <Col lg={5} className="double-otp-section text-center">
                    <div style={{ width: 80, margin: "0 auto", marginBottom: 20 }}>
                        <Lottie animationData={lockAnim} loop autoplay />
                    </div>

                    <div className={`double-otp-timer mb-4 ${ countdown <= 10 ? "red" : "default"}`}>
                        Le code est généré chaque 30s
                    </div>

                    <OtpInputBlock otp={otp} setOtp={setOtp} />

                    <Button
                        type="primary"
                        disabled={loading}
                        onClick={handleVerify}
                        className="double-confirm-button mt-4"
                    >
                        {loading ? <Spin size="small" /> : "Activer"}
                    </Button>
                </Col>
                </Row>
            ) : (
                <TwoFaEnabled/>
            )
        )   
};

export default QrCodeSetup;
